module.exports = __webpack_public_path__ + "media/pages/press/downloads/thumbnails/LifeTime_Produkt_tn-48a9776d1e904bca8364becc20d8baae.jpg";